import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useMediaDevice } from '@travelity/ui';

export interface AddButtonProps extends ButtonProps {
    text: string;
}

export const AddButton: React.FC<AddButtonProps> = props => {
    const { text, ...rest } = props;
    const { isMobile } = useMediaDevice();

    return (
        <Button
            variant="contained"
            color="secondary"
            {...rest}
            sx={{
                px: isMobile ? '6px' : undefined,
                minWidth: { xs: '36px', sm: '64px' },
            }}
        >
            {isMobile ? <AddIcon /> : text}
        </Button>
    );
};
